import React from 'react';
import { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CONSTANTS from '../util/constants';
import DataTable from "react-data-table-component";
import { useNavigate } from 'react-router-dom';

const Notification = (props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const gridRef = useRef();

    const notificationData = useSelector((state) => state.notification.getNotificationResponse);
    const [notifaction, setNotication] = useState([]);
    const [loading, setLoading] = useState(false);

    const [columnDefs, setColumnDefs] = useState([
        {
            name: "Notification No",
            selector: (row, index) => { return (index + 1) },
            disableSortBy: true
        },
        {
            name: 'Notification', width: "40rem", filter: true, resizable: true, flex: 1, selector: params => {
                let notifaction = params?.notificationText ? params?.notificationText : '';
                return (notifaction);
            }
        },
        {
            width: "6rem", name: 'Read', filter: true, resizable: true, flex: 1,
            cell: row => (
                !row?.isRead ?
                    <div onClick={() => {
                        row.isRead = true;
                        let obj = row;
                        let payloadNotification = {
                            isRead: true,
                            notificationIds: [row.notification_id]
                        }
                        dispatch({
                            type: CONSTANTS.CONSTANTS_NOTIFICATIONS_MANAGEMENT.EDIT_NOTIFICATIONS_API_CALL, payload: { value: payloadNotification }
                        })
                    }}>
                        <img style={{ marginLeft: 20, height: 32 }} src={require('./../assets/Dashboard/readIcon.png')} />
                    </div>
                    : null
            )
        },
    ])

    useEffect(() => {
        setLoading(true);
        dispatch({ type: CONSTANTS.CONSTANTS_NOTIFICATIONS_MANAGEMENT.GET_NOTIFICATIONS_API_CALL })
    }, []);

    useEffect(() => {
        setLoading(false);
        if (notificationData && notificationData?.length > 0 && notificationData != 'Failed') {
            setNotication(notificationData)
        }
    }, [notificationData])

    return (
        <div>
            <div className='row'>

                <div className="col-md-12 col-sm-12 row-10 ag-theme-alpine mt-4" style={{
                    height: '80vh', width: '80vw', margin: 'auto'
                }}>
                    {notifaction && notifaction.length > 0 ?
                        <DataTable
                            ref={gridRef}
                            getRowClassName={(params) => `super-app-theme--${params.row.status}`}
                            columns={columnDefs}
                            data={notifaction}
                            responsive={true}
                            tooltipShowDelay={0}
                            tooltipHideDelay={2000}
                            progressPending={loading}
                            pagination
                            paginationServer
                            selectableRows

                        />
                        : 'No Data Available'}
                </div>
            </div>
        </div>
    )
}

export default Notification;